import React from 'react';
import { CheckableButton } from "components/CheckableButton/CheckableButton";

interface CheckboxSettingsProps {
    object: any;
}

export const CheckboxSettings: React.FC<CheckboxSettingsProps> = ({ object }) => {
    return (
        <div className="col-12">
            <div className="d-flex align-items-end w-100 h-100">
                <CheckableButton
                    type="checkbox"
                    labelText="defaultValue"
                    inputName="defaultValue"
                    defaultChecked={object?.defaultValue || false}
                    defaultValue={object?.defaultValue || false}
                />
            </div>
        </div>
    );
}; 